// src/utils/taskFilters.js

const roleLower = (r) => (r || "").toString().trim().toLowerCase();

export function filterTasksForUser(tasks, me) {
  const list = Array.isArray(tasks) ? tasks : [];
  if (!me) return [];

  const role = roleLower(me.role);
  if (role === "owner" || role === "admin") return list;

  const myUid = me.uid || null;
  const myDocId = me.id || null;

  // match both uid and doc id (older tasks may store either)
  const myIds = new Set([myUid, myDocId].filter(Boolean));

  const myGroupIds = new Set((Array.isArray(me.groupIds) ? me.groupIds : []).filter(Boolean));

  return list.filter((t) => {
    if (!t) return false;

    // optional: if you ever add "visibility" field later
    if (t.visibility === "private" && !myIds.has(t.createdByUid)) return false;

    const assignMode = (t.assignMode || "users").toString();
    const assignedTo = Array.isArray(t.assignedToUserIds) ? t.assignedToUserIds : [];
    const memberIds = Array.isArray(t.memberIds) ? t.memberIds : [];
    const perUser = t.perUser && typeof t.perUser === "object" ? t.perUser : {};
    const groupId = t.groupId || "";

    // ✅ allow tasks they created
    if (t.createdByUid && myIds.has(t.createdByUid)) return true;

    // ✅ direct assignment
    for (const id of assignedTo) if (myIds.has(id)) return true;

    // ✅ joint membership (memberIds OR perUser keys)
    for (const id of memberIds) if (myIds.has(id)) return true;
    for (const id of myIds) if (id && Object.prototype.hasOwnProperty.call(perUser, id)) return true;

    // ✅ group assignment
    if (assignMode === "group" && groupId && myGroupIds.has(groupId)) return true;

    return false;
  });
}
